<script>
import {
  TrailerType,
  TruckAdditionalEquipment,
  TruckDoorType,
  TruckEquipment,
  TruckStatus,
  TruckStatusList,
  TruckTypeList,
} from "@/constants/truck.ts";
import { useAppStore } from "@/store/app.store.ts";

export default {
  name: "TrucksMixin",
  data() {
    return {
      truckStatusAvailable: TruckStatus.Available,
      truckStatusWillBeAvailable: TruckStatus.WillBeAvailable,
      truckStatusOnHold: TruckStatus.OnHold,
      truckStatusInRoute: TruckStatus.InRoute,
      truckStatusNotAvailable: TruckStatus.NotAvailable,
      doorTypes: TruckDoorType,
      equipment: TruckEquipment,
      additionalEquipment: TruckAdditionalEquipment,
      truckStatuses: TruckStatusList,
      trucksWithTrailer: TruckTypeList.filter((t) => t.hasTrailer).map((t) => t.id),
      truckTypes: TruckTypeList,
      trailerTypes: TrailerType,
    };
  },
  methods: {
    getEquipments(arr, value) {
      const map = {};
      for (const item of arr) {
        map[item.id] = item.name;
      }

      return value.map((key) => map[key] || "");
    },
    getTruckSize(truck) {
      return `${truck.trailer.length}″ x ${truck.trailer.width}″ x ${truck.trailer.height}″`;
    },
    getTruckType(type) {
      for (const t of this.truckTypes) {
        if (t.id === type) return t.name;
      }
      return "";
    },

    getReservationTime(truck) {
      if (!truck.reservedTill) {
        return -1;
      }

      return this.$dayjs(truck.reservedTill).diff(this.$dayjs(), "minutes");
    },
    isReservedByDispatcher(truck, dispatcherId) {
      if (!truck.reservedById) return false;
      return truck.reservedById === dispatcherId;
    },
    getReservedBy(truck) {
      const appStore = useAppStore();
      if (truck.reservedById === appStore.dispatcher.id) return "(you)";
      return (appStore.getDispatcher(truck.reservedById) || {}).name;
    },
  },
};
</script>
